var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChangeStationIcon = function SvgChangeStationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0429 0.896484H16.0429V4.3945C14.3699 2.29369 11.8033 1.00004 9 1.00004C4.02944 1.00004 0 5.02947 0 10C0 14.9706 4.02944 19 9 19C13.9706 19 18 14.9706 18 10H16C16 13.866 12.866 17 9 17C5.13401 17 2 13.866 2 10C2 6.13404 5.13401 3.00004 9 3.00004C11.2924 3.00004 13.3811 4.11191 14.6728 5.89648L11.0429 5.89648V7.89648L17.0429 7.89648C17.5952 7.89648 18.0429 7.44877 18.0429 6.89648V0.896484Z",
    fill: "#3F7F7D"
  })));
};
export { SvgChangeStationIcon as ReactComponent };
export default __webpack_public_path__ + "assets/3e6cf2de.svg";